export { portalContainsElement } from '@fluentui/dom-utilities';
//# sourceMappingURL=portalContainsElement.js.map